import * as $ from "jquery";

var $geofilterWrapper = $(".geofilter-wrapper");
var $geofilters = $geofilterWrapper.find("a");
var $sectionEvents = $("#sectionEvents");
var $eventColumns = $sectionEvents.find(".mag-columnEvent");
var $noEventsColumn = $("#noEventsColumn");
var $noGeoEventsColumn = $("#noGeoEventsColumn");
var SECTION_EVENTS_DISABLED_CLASS = "section__company-events--disabled";
var SELECTED_CLASS = "filter-active";
var LAST_VISIBLE_CLASS = "mag-columnEvent--last-visible";

var assignLastColumn = function () {
  $eventColumns.removeClass(LAST_VISIBLE_CLASS);
  $sectionEvents
    .find(".mag-columnEvent:visible:last")
    .addClass(LAST_VISIBLE_CLASS);
};

$geofilters.on("click", function () {
  var $this = $(this);
  var link = $this.attr("href").replace("#", "");
  var selectOn = $('.mag-columnEvent[data-geofilters*="' + link + '"]');
  var selectOff = $('.mag-columnEvent:not([data-geofilters*="' + link + '"])');

  if (!$this.hasClass(SELECTED_CLASS)) {
    $geofilters.removeClass(SELECTED_CLASS);
    $this.addClass(SELECTED_CLASS);

    selectOff.hide();
    selectOn.show();
    assignLastColumn();

    if (!selectOn.length) {
      $noGeoEventsColumn.show();
      $sectionEvents.addClass(SECTION_EVENTS_DISABLED_CLASS);
    } else {
      $noGeoEventsColumn.hide();
      $sectionEvents.removeClass(SECTION_EVENTS_DISABLED_CLASS);
    }
  } else {
    $geofilters.removeClass(SELECTED_CLASS);
    $eventColumns.show();
    $noGeoEventsColumn.hide();
    $sectionEvents.removeClass(SECTION_EVENTS_DISABLED_CLASS);
    assignLastColumn();
  }
  return false;
});

// on initial load, if no events found show 'no events' message
$(window).load(function () {
  assignLastColumn();

  if (!$eventColumns.length) {
    $noEventsColumn.show();
    $sectionEvents.addClass(SECTION_EVENTS_DISABLED_CLASS);
    $geofilters.off("click");
  }
});
